import { memo, useCallback, useEffect, useState } from "react";
import "./FilesFilterRow.scss";
import { Input, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { pushBatchDetails } from "../../../ReduxComponents/Reducers/BatchReducer";
import { debounce } from "lodash";

const NameFilter = () => {
	const {
		batchReducer: { searchName },
	} = useSelector((state) => state);
	const dispatch = useDispatch();
	const [searchText, setSearchText] = useState(searchName);

	const updateFilter = useCallback(
		debounce(() => {
			dispatch(
				pushBatchDetails({
					searchName: searchText,
					currentPage: 1,
					test: "tetsing",
				})
			);
		}, 500),
		[searchText]
	);

	useEffect(() => {
		setSearchText(searchName);
	}, [searchName]);

	const handleNameChange = (e) => {
		setSearchText(e);
	};

	useEffect(() => {
		if (searchText !== searchName) {
			updateFilter();
		}
		return () => updateFilter.cancel();
	}, [updateFilter, searchText]);

	return (
		<>
			<Typography.Text className="file-name-search">
				<Input.Search
					value={searchText}
					onChange={(e) => {
						handleNameChange(e.target.value);
					}}
					className="name-filter"
					placeholder="File name"
					allowClear
				/>
			</Typography.Text>
		</>
	);
};

export default memo(NameFilter);
